<template>
  <v-dialog
      :value="cambia"
      persistent
  >
    <v-card>
      <v-card-title>
        <span class="headline">Nuevo</span>
      </v-card-title>
      <v-card-subtitle>
        Primero ingresa el email para saber si la persona existe en nuestro sistema, si no existe tendras que asignarle un Nombre y Apellido Paterno.

      </v-card-subtitle>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field  v-model="pemail"  type="email" @change="verificaremail" label="Email"></v-text-field>
            </v-col>
            <v-col  cols="12" sm="12" md="12" lg="12">
              <v-text-field   v-model="pnombres" label="Nombre"></v-text-field>
            </v-col>
            <v-col  cols="12" sm="12" md="12" lg="12">
              <v-text-field   v-model="pappaterno" label="Apellido Paterno"></v-text-field>
            </v-col>

          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('cierra')">Cancelar</v-btn>
        <v-btn color="blue darken-1" text @click="nuevo">Grabar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "crearpromo",
  props:{
    cambia: Boolean,
    promotor: {
      type: Object
    }
  },
  data: () => ({
    pemail:'',
    pnombres:'',
    pappaterno:'',

    emailexist: false,
  }),
  methods:{
    nuevo(){
      this.overlay=true;
      var bodyFormData2 = new FormData();
      bodyFormData2.append("email",this.pemail);
      bodyFormData2.append("nombre",this.pnombres);
      bodyFormData2.append("apellidoPaterno",this.pappaterno);
      bodyFormData2.append("hash",this.promotor.hashPromotor);
      axios
          .post('personas/email',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.overlay = false
            if(response.data){
              this.$emit('cierra')
            }else
            {
              this.$emit('cierra')
            }
          })
          .catch((error)  => {
            this.overlay = false
            console.log(error);
          });
    },
    verificaremail(){
      this.overlay=true;
      var bodyFormData2 = new FormData();
      bodyFormData2.append("email",this.pemail);
      axios
          .post('personas/email',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.overlay=false
            let persona = response.data
            if (persona.id == null){

              this.pnombres = ''
              this.pappaterno = ''
              this.idpersona = 0
            }else{
              this.pnombres = persona.nombre
              this.pappaterno = persona.apellidoPaterno
              this.idpersona = persona.id
            }

          })
          .catch((error)  => {
            this.overlay = false
            console.log(error);
          });
    },
  }
}
</script>

<style scoped>

</style>
